// FirebaseUI
import { Box, Button, Typography } from '@mui/material';
import firebase from 'firebase/compat/app';
import * as firebaseui from 'firebaseui'
import DownloadIcon from '@mui/icons-material/Download';
import ClosetImage from '../closet.jpeg'
import CheckroomIcon from '@mui/icons-material/Checkroom';
import DownloadInstruccions from './DownloadInstruccions';

import 'firebaseui/dist/firebaseui.css'
import { useTranslation } from 'react-i18next';

// React stuff
import { useEffect, useState } from 'react';

// Auth service
import auth from '../lib/auth.js';
import AboutUs from './AboutUs';

const SignIn = ({ installPrompt }) => {

  const uiConfig = {
    signInSuccessUrl: '/',
    callbacks: {
      signInSuccessWithAuthResult: function (/* authResult, redirectUrl */) {
        return true; // return true so that it automatically redirects
      },
    },
    signInOptions: [ // This array contains all the ways an user can authenticate in your application. For this example, is only by email.
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false
      }
    ]
  }

  useEffect(() => {
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
    ui.start('#firebaseui-auth-container', uiConfig);
  }, []);

  const { t } = useTranslation();
  const [openDownLoadInstruccions, setOpenDownLoadInstruccions] = useState(false);

  const handleDownloadRequest = () => {
    if (!installPrompt) {
      setOpenDownLoadInstruccions(true)
      return;
    }
    installPrompt.prompt()
  }

  return (
    <Box>
      <Box sx={{ backgroundImage: `url(${ClosetImage})`, backgroundSize: "cover", color: "#f5f5f5" }}>
        <Box sx={{ height: '600px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h5" component="h1" sx={{ textAlign: 'center', color: 'white', fontWeight: 'medium', mb: 3, alignItems: 'center' }}>
              Get the app
              <CheckroomIcon />
            </Typography>
            <Button onClick={handleDownloadRequest} sx={{ backgroundColor: 'white', color: 'black' }}
              variant="contained" autoFocus color="primary"> <DownloadIcon />Download</Button>
          </Box>
          <Typography variant="h5" component="h1" sx={{ textAlign: 'center', color: 'white', fontWeight: 'medium', mb: 3, alignItems: 'center' }}>
              {t('signIn')}:
          </Typography>
          <Box id="firebaseui-auth-container"></Box>
        </Box>
      </Box>
      <DownloadInstruccions openDownLoadInstruccions={openDownLoadInstruccions} setOpenDownLoadInstruccions={setOpenDownLoadInstruccions} />
      <AboutUs />
    </Box>
  )
}

export default SignIn;
